/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Webhook_UrlInputs */

const cs_field_webhook_url = /** @type {(inputs: Field_Webhook_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook URL`)
};

const en_field_webhook_url = /** @type {(inputs: Field_Webhook_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook URL`)
};

/**
* | output |
* | --- |
* | "Webhook URL" |
*
* @param {Field_Webhook_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_webhook_url = /** @type {((inputs?: Field_Webhook_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Webhook_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_webhook_url(inputs)
	return cs_field_webhook_url(inputs)
});